<template>
  <div v-if="datum" class="wrap" @click="dtl">
    <div class="imgWrp">
      <div class="swiper-wrap">
        <swiper
          :options="{
            navigation: {
              nextEl: '.button-next' + btnNum,
              prevEl: '.button-prev' + btnNum,
              loop: true
            }
          }"
        >
          <swiper-slide v-for="(img, index) in datum.imgLst" :key="index">
            <div
              :style="{ backgroundImage: 'url(' + img + ')' }"
              class="img"
            ></div>
          </swiper-slide>
          <div
            v-if="btnNum == 1"
            slot="button-prev"
            class="swiper-button-prev button-prev1"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 1"
            slot="button-next"
            class="swiper-button-next button-next1"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 2"
            slot="button-prev"
            class="swiper-button-prev button-prev2"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 2"
            slot="button-next"
            class="swiper-button-next button-next2"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 3"
            slot="button-prev"
            class="swiper-button-prev button-prev3"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 3"
            slot="button-next"
            class="swiper-button-next button-next3"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 4"
            slot="button-prev"
            class="swiper-button-prev button-prev4"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 4"
            slot="button-next"
            class="swiper-button-next button-next4"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 5"
            slot="button-prev"
            class="swiper-button-prev button-prev5"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 5"
            slot="button-next"
            class="swiper-button-next button-next5"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 6"
            slot="button-prev"
            class="swiper-button-prev button-prev6"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 6"
            slot="button-next"
            class="swiper-button-next button-next6"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 7"
            slot="button-prev"
            class="swiper-button-prev button-prev7"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 7"
            slot="button-next"
            class="swiper-button-next button-next7"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 8"
            slot="button-prev"
            class="swiper-button-prev button-prev8"
            @click.stop
          ></div>
          <div
            v-if="btnNum == 8"
            slot="button-next"
            class="swiper-button-next button-next8"
            @click.stop
          ></div>
        </swiper>
      </div>
      <div
        v-if="tag"
        :class="[getNotCollectedTenant(), getCollectedTenant()]"
        class="collect"
        @click.stop="change2(datum.favoritesFlag)"
      ></div>
    </div>
    <div class="line">
      <div class="innr"></div>
    </div>
    <div class="outWrp">
      <div class="txtWrp">
        <div class="txtCon">
          <h2>
            ${{ datum.price
            }}<span
              v-if="
                datum.maxPrice &&
                  datum.maxPrice !== '' &&
                  datum.maxPrice !== '0' &&
                  datum.maxPrice !== 0
              "
            >
              - ${{ datum.maxPrice }}</span
            >
          </h2>
          <h3>{{ datum.proertyType }}</h3>
          <h4>
            <span v-if="datum.apt && datum.apt !== ''">{{ datum.apt }} / </span
            >{{ datum.address }} {{ datum.suburb }}
          </h4>
          <h5>{{ datum.state }} {{ datum.postcode }}</h5>
          <div class="dtl" v-bind:class="'tenant-' + tenant">
            <p>
              <span>Estimated commencement</span
              ><span>{{ datum.estimatedCommenceMent }}</span>
            </p>
            <p>
              <span>Estimated completion</span
              ><span>{{ datum.estimatedCompletion }}</span>
            </p>
            <p>
              <span>Estimated rental<br />(per week)</span>
              <span style="margin-top:.05rem"
                >${{ datum.rental }}
                <i
                  v-if="datum.maxRental"
                  style="font-style:normal;display:block;line-height:.2rem;"
                >
                  -
                </i>
                <i
                  v-if="datum.maxRental"
                  style="font-style:normal;display:block;"
                  >${{ datum.maxRental }}</i
                >
              </span>
            </p>
            <p v-if="datum.proertyType === 'House & Land'">
              <!--房子类型为house and land时显示-->
              <span>Land price</span><span>${{ datum.landPrice }}</span>
            </p>
            <p v-if="datum.proertyType === 'House & Land'">
              <!--房子类型为house and land时显示-->
              <span>Build price</span><span>${{ datum.buildPrice }}</span>
            </p>
            <p>
              <span>Rental yield</span><span>{{ datum.rentalYield }}%</span>
            </p>
            <p>
              <span>Incentives</span><span v-html="datum.incentives"></span>
            </p>
          </div>
          <transition name="btn">
            <div
              v-if="
                mode === 'off' &&
                  (curMode === 'off' || curMode === '') &&
                  datum.clickFlag == true
              "
              :class="{
                huan:
                  datum.maxCommision !== null &&
                  datum.maxCommision !== undefined &&
                  datum.maxCommision !== '' &&
                  datum.maxCommision !== '0' &&
                  datum.maxCommision !== 0
              }"
              class="btn clear"
            >
              Your commission
              <span
                >${{ datum.commision
                }}<i
                  v-if="
                    datum.maxCommision !== null &&
                      datum.maxCommision !== undefined &&
                      datum.maxCommision !== '' &&
                      datum.maxCommision !== '0' &&
                      datum.maxCommision !== 0
                  "
                  style="font-style:normal"
                >
                  - ${{ datum.maxCommision }}</i
                ></span
              >
            </div>
            <div v-if="datum.clickFlag == false" class="expire">Expired</div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      mode: "off",
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  props: {
    btnNum: {
      type: Number,
      default: () => {
        return 1;
      }
    },
    datum: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tag: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    cur: {
      type: Number,
      default: () => {
        return 1;
      }
    }
  },
  created() {
    var that = this;
    if (localStorage.getItem("mode")) {
      that.mode = localStorage.getItem("mode");
      console.log(that.mode);
      that.change({ data: that.mode });
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    ...mapMutations("login", ["change"]),
    dtl() {
      var that = this;
      if (that.datum.clickFlag == false) {
        that.$box.alert("", "sell out", "error");
        return;
      } else {
        // 已购买
        if (that.datum.sellFlag == "2") {
          sessionStorage.setItem("ppage", this.cur);
          if (!that.datum.roomId) {
            that.$router.push(
              `/account/purchased/${that.datum.propertyId}/room/${that.datum.orderId}`
            );
          } else {
            that.$router.push(
              `/account/purchased/${that.datum.propertyId}/${that.datum.roomId}/${that.datum.orderId}`
            );
          }
        }
        // 已预定
        else if (that.datum.sellFlag == "1") {
          sessionStorage.setItem("rpage", this.cur);
          if (!that.datum.roomId) {
            if (that.datum.ordersId) {
              //that.$router.push(`/index/property/${that.datum.propertyId}/room/1?ordersId=${that.datum.ordersId}`)
              that.$router.push(
                `/account/reserved/${that.datum.propertyId}/room/${that.datum.orderId}`
              );
            } else {
              //that.$router.push(`/index/property/${that.datum.propertyId}/room/1`)
              that.$router.push(
                `/account/reserved/${that.datum.propertyId}/room/${that.datum.orderId}`
              );
            }
          } else {
            if (that.datum.ordersId) {
              //that.$router.push(`/index/property/${that.datum.propertyId}/${that.datum.roomId}/1?ordersId=${that.datum.ordersId}`)
              that.$router.push(
                `/account/reserved/${that.datum.propertyId}/${that.datum.roomId}/${that.datum.orderId}`
              );
            } else {
              //that.$router.push(`/index/property/${that.datum.propertyId}/${that.datum.roomId}/1`)
              that.$router.push(
                `/account/reserved/${that.datum.propertyId}/${that.datum.roomId}/${that.datum.orderId}`
              );
            }
          }
        }
        // 未购买未预定（不会详细到房间号）
        else if (that.datum.sellFlag == "0") {
          sessionStorage.setItem("bpage", this.cur);
          that.$router.push(
            `/index/property/${that.datum.propertyId}/room/${that.datum.operate}`
          );
        }
        // 如果没有sellFlag，是从首页进入的
        else if (!that.datum.sellFlag) {
          sessionStorage.setItem("spage", this.cur);
          that.$router.push(`/index/property/${that.datum.propertyId}/room/0`);
        }
      }
    },
    change2(type) {
      var that = this;
      if (type === "no") {
        that.$emit("accept", "no", that.datum.propertyId);
      } else {
        that.$emit("accept", "yes", that.datum.propertyId);
      }
    },
    getCollectedTenant() {
      var val = "";
      if (this.datum.favoritesFlag == "yes") {
        val = "collected-" + this.tenant;
      }
      return val;
    },
    getNotCollectedTenant() {
      var val = "";
      if (this.datum.favoritesFlag == "no") {
        val = "notCollected-" + this.tenant;
      }
      return val;
    }
  },
  computed: {
    ...mapState({
      curMode: state => state.login.mode // 实时变化
    })
  },
  watch: {
    curMode(val) {
      this.mode = localStorage.getItem("mode");
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  margin-bottom: 0.48rem;
  position: relative;

  .imgWrp {
    width: 100%;
    height: 5rem;
    position: relative;

    .swiper-wrap {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 100%;
    }

    .img {
      width: 100%;
      height: 5rem;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-color: #3f3f46;
    }

    .collect {
      position: absolute;
      top: 0;
      left: 0;
      width: 0.86rem;
      height: 0.92rem;
      background-position: center center;
      background-repeat: no-repeat;
      z-index: 5;
      cursor: pointer;
    }

    .notCollected {
      background-image: url("../../assets/tag.png");
    }

    .collected {
      background-image: url("../../assets/tag2.png");
    }
  }

  .line {
    width: 100%;
    padding: 0 0.24rem;
    position: absolute;
    left: 0;
    top: 4.85rem;
    z-index: 1;
    box-sizing: border-box;

    .innr {
      width: 100%;
      height: 0.2rem;
      background: #fff;
      box-shadow: 0px -0.2rem 0.32rem 0px rgba(0, 0, 0, 0.08);
      border-top-left-radius: 0.04rem;
      border-top-right-radius: 0.04rem;
    }
  }

  .outWrp {
    width: 100%;
    padding: 0 0.24rem;
    box-sizing: border-box;
  }

  .txtWrp {
    width: 100%;
    background: #fff;
    margin: -0.2rem auto 0 auto;
    box-shadow: 0px 0.04rem 0.16rem 0px rgba(0, 0, 0, 0.08);
    border-radius: 0.02rem 0.02rem 0px 0px;
    transition: all 0.5s;

    .txtCon {
      width: 100%;
      box-sizing: border-box;
      padding: 0.3rem 0.32rem;

      h2 {
        text-align: right;
        font-size: 0.32rem;
        color: #3f3f46;
        margin-bottom: 0.06rem;
      }

      h3 {
        font-size: 0.24rem;
        color: #979497;
        margin-bottom: 0.1rem;
      }

      h4 {
        font-size: 0.5rem;
        color: #3f3f46;
        margin-bottom: 0.12rem;
        word-break: break-word;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      h5 {
        font-size: 0.4rem;
        color: #979497;
        margin-bottom: 0.4rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .dtl {
        width: 100%;
        position: relative;
        padding: 0.06rem 0;
        margin-bottom: 0.22rem;

        p {
          font-size: 0.28rem;
          color: #979497;
          margin-bottom: 0.1rem;
          display: flex;
          flex-direction: row;

          span:nth-child(1) {
            flex: 0 0 auto;
            width: 3.2rem;
            text-align: right;
            vertical-align: top;
            margin-right: 0.35rem;
          }

          span:nth-child(2) {
            flex: 1;
            color: #3f3f46;
            display: inline-block;
            word-break: break-word;
          }
        }

        p:nth-last-child(1) {
          margin: 0;
        }
      }

      .dtl:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0.1rem;
        height: 2.5rem;
        //background:rgba(255,239,0,1);
      }

      .btn {
        border: none;
        width: 100%;
        height: 1rem;
        box-sizing: border-box;
        padding: 0 0.32rem;
        font-size: 0.28rem;
        background: rgba(63, 63, 70, 1);
        border-radius: 0.06rem;
        box-sizing: border-box;
        line-height: 1rem;
        cursor: pointer;
        color: #f3eff7;
        margin-top: 0.6rem;
        position: relative;

        span {
          font-size: 0.44rem;
          color: #fff;
          float: right;
        }
      }

      .huan {
        height: 1.3rem;
        line-height: 0.6rem;

        span {
          display: block;
          float: none;
          width: 100%;
          position: absolute;
          left: 0.32rem;
          white-space: nowrap;
        }
      }

      .expire {
        border: none;
        width: 100%;
        height: 1.04rem;
        line-height: 1.04rem;
        box-sizing: border-box;
        font-size: 0.44rem;
        background: rgba(63, 63, 70, 1);
        border-radius: 0.06rem;
        cursor: pointer;
        color: #f3eff7;
        text-align: center;
        margin-top: 0.6rem;
      }
    }
  }
}

.swiper-button-prev {
  background-image: url("../../assets/p.png");
  background-size: contain;
  background-repeat: no-repeat;
  width: 0.6rem;
  height: 0.6rem;
  left: 0.24rem;
  opacity: 1;
}

.swiper-button-next {
  background-image: url("../../assets/n.png");
  background-size: contain;
  background-repeat: no-repeat;
  width: 0.6rem;
  height: 0.6rem;
  right: 0.24rem;
  opacity: 1;
}

button {
  outline: none;
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0;
}

.btn-enter-active,
.btn-leave-active {
  transition: opacity 0.5s;
}

.btn-enter,
.btn-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/package/item.vue